// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback-holder{height:0;z-index:1}.feedback-button{position:fixed;left:.9%;top:50%;transform:translateX(-50%) translateY(-50%) rotate(-90deg)}", ""]);
// Exports
module.exports = exports;
